@if (isLoading()) {
  <ngx-skeleton-loader [theme]="{ height: '18px', marginBottom: 0 }" />
} @else {
  <span class="text-xs font-semibold">
    {{ title() }}
  </span>
}
